/*eslint-disable*/
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Spinner,
    FormGroup,
    Label,
    Input, Form,
    Alert,
} from "reactstrap";
import './roadmap.public.scss';

const CreateModal = ({
    toggleCreateModal,
    submitFeatureReq,
    roadmapPayload,
    setRoadmapPayload,
    featureSubmit,
    payloadValid,
    showCreateModal,
    featureSubmitLoader
}) => {
    const closeBtn = (
        <button className="close" onClick={toggleCreateModal} type="button">
            &times;
        </button>
    );

    return (
        <>
            <Modal
                isOpen={showCreateModal}
                toggle={toggleCreateModal}
                className="modal-dialog-centered"
            >
                <ModalHeader toggle={toggleCreateModal} close={closeBtn}>
                    Create a Post
                </ModalHeader>
                <ModalBody className=''>
                    <Form>
                        <FormGroup>
                            <Label for="post title">
                                Title
                            </Label>
                            <Input
                                id="post title"
                                className="title-input"
                                name="title"
                                placeholder="Enter title"
                                type="text"
                                value={roadmapPayload.title}
                                onChange={(e) => setRoadmapPayload({ ...roadmapPayload, title: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="post description">
                                Description
                            </Label>
                            <Input
                                id="post description"
                                name="description"
                                className="title-description"
                                placeholder="Why do you want this feature?"
                                type="textarea"
                                value={roadmapPayload.description}
                                style={{ height: '90px' }}
                                onChange={(e) => setRoadmapPayload({ ...roadmapPayload, description: e.target.value })}
                            />
                        </FormGroup>
                        <br></br>
                        <Button color="success" type="button"
                            className={`pl-btn submit-btn ${featureSubmitLoader ? 'disabled' : ''}`}
                            onClick={submitFeatureReq}>
                            {featureSubmitLoader && <Spinner color="primary" size="sm" style={{ marginRight: '5px' }} />}
                            Submit
                        </Button>


                        {
                            featureSubmit.show && (
                                <Alert color="primary" style={{ marginTop: '10px', padding: '8px', fontSize: '12px', width: 'fit-content' }}>
                                    {featureSubmit.text}
                                </Alert>
                            )
                        }
                        {
                            !payloadValid.status && (
                                <Alert color="warning" style={{ marginTop: '10px', padding: '10px', fontSize: '12px' }}>
                                    {payloadValid.error}
                                </Alert>
                            )
                        }
                    </Form>


                </ModalBody>
            </Modal>
        </>
    );
};

export default CreateModal;
